// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-container {
  padding: 0 1rem 1rem 1rem;
  min-width: 25rem;
}`, "",{"version":3,"sources":["webpack://./src/app/components/v-error-content/v-error-content.component.sass"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,gBAAA;AACJ","sourcesContent":[".content-container\n    padding: 0 1rem 1rem 1rem\n    min-width: 25rem"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
